import axios from "axios";
import { camelizeKeys } from 'humps';

axios.defaults.withCredentials = true;
axios.interceptors.response.use((response) => {
  response.data = camelizeKeys(response.data);
  return response;
});

const API_BASE = `https://fb-alimtalk.epinet.kr`;
// const API_BASE = `http://localhost:8000`;

const getRefinedFBSpots = (data) => {
  const getColor = (real, now) => {
    if (now === 0){
      return {value: 0, color: "#dcdcdc"};
    }else if (real === now){
      return {value: 1, color: "#006eff"}
    }else{
      return {value: 2, color: "#ff8686"};
    }
  };

  let newData = data && data.length > 0 ? data : [];
  return newData.map((item) => {
    return {
      ...item,
      'is_same': getColor(item.realNow, item.now),
    };
  });
};

export const getPesticideList = async (
  setDataCallBack,
  setLoadingCallBack,
  setErrorCallBack,
  targetCrop,
  targetYear,
  targetRegion
) => {
  const api = `${API_BASE}/api/alimtalk-monitor/region-pesticide/`;
  const params = {
    year: targetYear,
    plant: targetCrop.title,
    ...(targetRegion && targetRegion.region !== "all" && { region: targetRegion.region }),
  };
  try {
    setLoadingCallBack(true);
    const response = await axios.get(api, { params });
    setDataCallBack(response.data);
  } catch (e) {
    setErrorCallBack(e);
    alert("약제 정보 조회에 실패하였습니다.");
  }
  setLoadingCallBack(false);
};

export const getSendLog = async (
  setDataCallBack,
  setLoadingCallBack,
  setErrorCallBack,
  targetCrop,
  targetYear,
  targetRegion,
  stationId = null
) => {
  const api = `${API_BASE}/api/alimtalk-monitor/region-accumulative-send-count/`;
  const params = stationId
    ? { plant: targetCrop.title, year: targetYear, st: stationId, ...(targetRegion && targetRegion.region !== "all" && { region: targetRegion.region }) }
    : { plant: targetCrop.title, year: targetYear, ...(targetRegion && targetRegion.region !== "all" && { region: targetRegion.region }) };
  try {
    setLoadingCallBack(true);
    const response = await axios.get(api, { params });
    setDataCallBack(response.data);
  } catch (e) {
    setErrorCallBack(e);
    alert("발송 로그 조회에 실패하였습니다.");
  }
  setLoadingCallBack(false);
};

export const getSigunguList = async (setDataCallBack, setErrorCallBack) => {
  const api = `${API_BASE}/api/alimtalk-monitor/region`;
  try {
    const response = await axios.get(api);
    const data = response.data;
    setDataCallBack([{ region: 'all', regionDesc: "전체" }, ...data]);
  } catch (e) {
    setErrorCallBack(e);
    alert("시군 목록 조회에 실패하였습니다.");
  }
};

export const getFBSpotsAlimtalk = async (
  setDataCallBack,
  setLoadingCallBack,
  setErrorCallBack,
  targetCrop,
  targetYear,
  targetRegion
) => {
  const params = {
    plant: targetCrop.title,
    ...(targetRegion && targetRegion.region !== 'all' && { region: targetRegion.region }),
  };

  const api = `${API_BASE}/api/alimtalk-monitor/region-station-send-count`;

  try {
    setLoadingCallBack(true);
    setErrorCallBack();
    await axios.get(api, { params: { ...params } }).then((response) => {
      const data = response.data;
      setDataCallBack(
        getRefinedFBSpots(data)
      );
    });
  } catch (e) {
    setErrorCallBack(e);
    alert("해당 API 호출에 실패하였습니다. 재시도하여 주세요.");
  }
  setLoadingCallBack(false);
};
